import {
  getIdToken,
  getAccessToken,
  getUserInfo,
  isAuthenticated,
  isEmailVerified,
  showEmailConfirmation,
  showSilentLoginNotification,
  sendEmailVerification,
  getUserSubscriptions,
} from './auth0-sdk';

const queue = window.CIAM || [];
window.CIAM = {
  push: (fn: () => void) => {
    fn();
  },
  getIdToken,
  getAccessToken,
  getUserInfo,
  isAuthenticated,
  isEmailVerified,
  showEmailConfirmation,
  showSilentLoginNotification,
  sendEmailVerification,
  getUserSubscriptions,
};

if (Array.isArray(queue)) {
  queue.forEach((fn: () => void) => fn());
}

if (document.currentScript) {
  let clientId = document.currentScript.getAttribute('data-client-id');
  let brand = document.currentScript.getAttribute('data-brand');

  // @ts-ignore
  if (!clientId && typeof window.MEDIAHUIS !== 'undefined' && window.MEDIAHUIS.config && window.MEDIAHUIS.config.auth0) {
    // @ts-ignore
    clientId = window.MEDIAHUIS.config.auth0.clientId;
  }
  // @ts-ignore
  if (!brand && typeof document !== 'undefined') {
    // @ts-ignore
    brand = document.title.indexOf('-') ? document.title.split(' - ')[1] : '';
  }

  if (clientId && brand) {
    if (!document.getElementById('auth0_silent-login-root')) {
      var doc = document.createElement('div');
      doc.id = 'auth0_silent-login-root';
      document.body.appendChild(doc);
    }
    showSilentLoginNotification({
      clientId,
      brand,
    });
  } else {
    console.warn('Missing "data-client-id" or "data-brand" attribute');
  }
}
